import React, {useState, useEffect, useRef} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import axios from "axios";

const ReceiptRelationFulfillmentListComponent = (props) => {

  const {t, view} = props;
  const history = useHistory();
  const {id} = useParams();
  const [receiptRelationFulfillments, setReceiptRelationFulfillments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [receiptTypesDict, setReceiptTypesDict] = useState([]);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const dt = useRef(null);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1,
  });

  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      const params = new URLSearchParams(window.App.transformQueryParams(lazyParams).replace(/^\?/, ''));
      // params.set('search[fulfillment][operator]', '=');
      // params.set('search[fulfillment][value]', String(Number(props.fulfillmentId || id)));
      


      if (view === 'procurement') {
        params.set('search[purchase_order][operator]', '=');
        params.set('search[purchase_order][value]', String(Number(props?.purchaseOrderId)));
      } else if (view === 'project') {
        params.set('unique_receipts', '1');
        params.set('search[project][operator]', '=');
        params.set('search[project][value]', String(Number(props?.projectId)));
      } 
      else {
        params.set('search[fulfillment][operator]', '=');
        params.set('search[fulfillment][value]', String(Number(props.fulfillmentId || id)));
      }
      apiCall('get', `/api/v2/receipt-relation?${params.toString()}`)
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setReceiptRelationFulfillments(response.data.data.items)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button 
          icon="pi pi-eye" 
          className="p-button p-mr-2"
          tooltip={t('view')} 
          aria-label={t('view')}
          tooltipOptions={{position: 'left'}}
          disabled={!rowData.parent?.id}
          onClick={() => {
            if (rowData.parent?.id) {
              history.push('/finance/receipt/read/' + rowData.parent?.id, {
                from: history.location.pathname + history.location.search
              });
            }
          }} 
        />
        {/* {localStorage.getItem('roles').toString().includes('role_') &&
          <Button icon="pi pi-pencil" className="  p-button-warning p-mr-2"
                  tooltip={t('edit')} tooltipOptions={{position: 'left'}}
                  onClick={() => {
                    if(entity === 'tmp') {
                      history.push('/inventory/tmp/update/' + rowData.id)
                    }
                  }}/>
        }
        {localStorage.getItem('roles').toString().includes('role_') &&
          <Button icon="pi pi-trash" className="p-button-danger"
                  tooltip={t('delete')} tooltipOptions={{position: 'left'}}
                  onClick={() => {
                    if (window.confirm('A törlés megerősítésére van szükség!')) {
                      setLoading(true);
                      apiCall('delete', '/api/v2/tmp/' + rowData.id)
                        .then(response => {
                          window.App.toastShow('success', 'Sikeres törlés!');
                          window.App.setState({rerenderTmpList: Math.random()})
                        })
                        .catch(error => {
                          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                        })
                        .finally(() => {
                          setLoading(false);
                        })
                    }
                  }}
          />
        } */}
      </React.Fragment>
    );
  }

  const getReceiptTypeLabel = (receiptType) => {
    const found = receiptTypesDict.find(d => d.id === receiptType);
    return found ? found.name : (receiptType || '-');
  };

  const currencyPriority = ['HUF', 'EUR'];

  const sortCurrencies = (a, b) => {
    const ai = currencyPriority.indexOf(a);
    const bi = currencyPriority.indexOf(b);
    if (ai !== -1 && bi !== -1) return ai - bi;
    if (ai !== -1) return -1;
    if (bi !== -1) return 1;
    return String(a).localeCompare(String(b));
  };

  const buildTotalsByReceiptTypeAndCurrency = (amountField) => {
    const map = new Map();
    (receiptRelationFulfillments || []).forEach(row => {
      const receiptType = row?.parent?.receipt_type || '-';
      const currency = row?.parent?.currency || process.env.REACT_APP_CURRENCY_DEFAULT || 'HUF';
      const amount = Number(row?.parent?.[amountField]);
      if (!Number.isFinite(amount)) return;
      if (!map.has(receiptType)) {
        map.set(receiptType, new Map());
      }
      const currencyMap = map.get(receiptType);
      currencyMap.set(currency, (currencyMap.get(currency) || 0) + amount);
    });
    return map;
  };

  const renderReceiptTypeCurrencyTotals = (totalsMap) => {
    if (!totalsMap || totalsMap.size === 0) return null;
    const entries = Array.from(totalsMap.entries()).sort(([typeA], [typeB]) => {
      return getReceiptTypeLabel(typeA).localeCompare(getReceiptTypeLabel(typeB));
    });
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6, alignItems: 'flex-end' }}>
        {entries.map(([receiptType, currencyMap]) => {
          const currencyEntries = Array.from(currencyMap.entries()).sort(([a], [b]) => sortCurrencies(a, b));
          return (
            <div key={receiptType} style={{ textAlign: 'right' }}>
              <div style={{ fontWeight: 'bold', whiteSpace: 'nowrap' }}>
                {getReceiptTypeLabel(receiptType)}
              </div>
              {currencyEntries.map(([currency, sum]) => (
                <div key={`${receiptType}-${currency}`} style={{ whiteSpace: 'nowrap' }}>
                  {window?.App?.currencyFormatter
                    ? window.App.currencyFormatter(currency, sum)
                    : `${sum} ${currency}`}
                </div>
              ))}
            </div>
          );
        })}
      </div>
    );
  };

  const totalsByNetAmount = React.useMemo(() => {
    return buildTotalsByReceiptTypeAndCurrency('net_amount');
  }, [receiptRelationFulfillments, receiptTypesDict]);

  const totalsByVatAmount = React.useMemo(() => {
    return buildTotalsByReceiptTypeAndCurrency('vat_amount');
  }, [receiptRelationFulfillments, receiptTypesDict]);

  const totalsByGrossAmount = React.useMemo(() => {
    return buildTotalsByReceiptTypeAndCurrency('gross_amount');
  }, [receiptRelationFulfillments, receiptTypesDict]);

  const netFooter = React.useMemo(() => {
    return renderReceiptTypeCurrencyTotals(totalsByNetAmount);
  }, [totalsByNetAmount, receiptTypesDict]);

  const vatFooter = React.useMemo(() => {
    return renderReceiptTypeCurrencyTotals(totalsByVatAmount);
  }, [totalsByVatAmount, receiptTypesDict]);

  const grossFooter = React.useMemo(() => {
    return renderReceiptTypeCurrencyTotals(totalsByGrossAmount);
  }, [totalsByGrossAmount, receiptTypesDict]);

  useEffect(() => {
    apiCall('get', `/api/v2/dictionary/receipt-type`)
      .then(response => {
        const raw = response?.data?.data || [];
        setReceiptTypesDict(raw.map(item => ({ 
          id: item.key || item.id, 
          name: item.value || item.name 
          })));
      })
        .catch(error => console.error("Szótár hiba:", error));
  }, []);

  useEffect(() => {
    loadLazyData();
  }, [lazyParams, window.App.state.rerenderReceiptRelationFulfillmentList])

  return (
    <>
      <DataTable size={localStorage.getItem('scale')}
                 emptyMessage={t('noResults')}
                 value={receiptRelationFulfillments} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
                 onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                 onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
                 paginatorTemplate={pager} rows={rows}
                 autoLayout={true}
                 responsiveLayout="scroll"
                 stripedRows
                 ref={dt}
                 dataKey="id"
      >
        <Column header={t('columnDocumentNumber2')} body={(rowData) => rowData.parent?.receipt_number || '-'} />
        <Column field="parent.partner_name" sortable header={t('columnPartner')} body={(rowData) => rowData.parent?.partner_name || '-'} />
        <Column header={t('columnType')} body={(rowData) => {
            const found = receiptTypesDict.find(d => d.id === rowData.parent?.receipt_type);
            return found ? found.name : (rowData.parent?.receipt_type || '-');
        }} />
        
        <Column header={t('columnNet')} footer={netFooter} className="p-text-right" 
            body={(rowData) => window.App.currencyFormatter(rowData.parent?.currency || process.env.REACT_APP_CURRENCY_DEFAULT, 
        rowData.parent?.net_amount)} 
        />
        <Column header={t('columnVat')} footer={vatFooter} className="p-text-right" 
            body={(rowData) => window.App.currencyFormatter(rowData.parent?.currency || process.env.REACT_APP_CURRENCY_DEFAULT, 
        rowData.parent?.vat_amount)} 
        />
        <Column header={t('columnGross')} footer={grossFooter} className="p-text-right" 
            body={(rowData) => window.App.currencyFormatter(rowData.parent?.currency || process.env.REACT_APP_CURRENCY_DEFAULT, 
        rowData.parent?.gross_amount)} 
        />
        <Column body={actionBodyTemplate} className={"p-py-0 p-text-right p-text-nowrap"}></Column>
      </DataTable>
    </>
  )
}
export default withTranslation('common')(ReceiptRelationFulfillmentListComponent);
